// Publish only owner-approved marketing details here. Never import private
// property, tenant, financial, or vault records into a public route.
// Keep this empty unless you explicitly decide to publish a vacancy.
// Addresses, rents, occupants, and portfolio data belong in the authenticated workspace.
export const publicListings = [];
